export enum SearchType {
    // in keyword search; we search as the user types
    KEYWORD_SEARCH = "multiple field search",
    // In tag field search; we search as the user selects specific tags like coins, people, companies.
    TAG_FIELD_SEARCH = "tag field search",
}
